function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGaleWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#212121",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "M 1.0117591,0.85544332 0.98394308,15.194247"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#212121",
      fillOpacity: 1,
      stroke: "#212121",
      strokeWidth: "0.935953px",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeOpacity: 1
    },
    d: "M 2.4175534,0.82338619 15.040527,7.1032513 2.4175534,11.896128 Z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGaleWarning);
export default __webpack_public_path__ + "static/media/gale-warning.97d71b468864f5d3a6952578306297de.svg";
export { ForwardRef as ReactComponent };